<template>
    <div class="ef-account-app-page">
        <div class="ef-account-app-page__inner">
            <img
                src="/elite-logo-white.png"
                alt="ELITE fitness"
                class="ef-account-app-page__logo"
                width="200"
                height="86"
                decoding="async"
            />
            <p class="ef-account-app-page__claim">
                Vai all'app ed inizia ad allenarti con Elite Fitness!
            </p>
            <div class="ef-account-app-page__stores">
                <a
                    :href="iosStore"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="ef-account-app-page__store-link"
                >
                    <img
                        src="/badge-app-store.svg"
                        alt="Scarica dall'App Store"
                        class="ef-account-app-page__badge"
                        width="120"
                        height="40"
                    />
                </a>
                <a
                    :href="androidStore"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="ef-account-app-page__store-link"
                >
                    <img
                        src="/badge-google-play.svg"
                        alt="Disponibile su Google Play"
                        class="ef-account-app-page__badge"
                        width="120"
                        height="40"
                    />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import {
    ELITE_IOS_APP_STORE,
    ELITE_ANDROID_PLAY_STORE,
    tryOpenAppThenStore,
} from '@/utils/appStores';

export default {
    data() {
        return {
            iosStore: ELITE_IOS_APP_STORE,
            androidStore: ELITE_ANDROID_PLAY_STORE,
            redirectTimer: null,
        };
    },
    mounted() {
        if (this.$route.query.target === 'download') {
            return;
        }
        const search = this.$route.fullPath.startsWith(this.$route.path)
            ? this.$route.fullPath.slice(this.$route.path.length)
            : '';
        this.redirectTimer = tryOpenAppThenStore(this.$route.path, search);
    },
    unmounted() {
        if (this.redirectTimer != null) {
            clearTimeout(this.redirectTimer);
        }
    },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap');

/* Stesso sfondo animato della login (LoginPage.vue) */
.ef-account-app-page {
    --ef-safe-top: 0px;
    --ef-safe-left: 0px;
    --ef-safe-right: 0px;
    --ef-safe-bottom: 0px;
    margin-top: calc(-1 * var(--ef-safe-top));
    margin-left: calc(-1 * var(--ef-safe-left));
    margin-right: calc(-1 * var(--ef-safe-right));
    min-height: calc(100dvh + var(--ef-safe-top));
    min-height: calc(100svh + var(--ef-safe-top));
    position: relative;
    overflow: hidden;
    background: linear-gradient(
        125deg,
        #172554 0%,
        #1e3a8a 18%,
        #2563eb 38%,
        #1d4ed8 55%,
        #312e81 72%,
        #1e40af 88%,
        #172554 100%
    );
    background-size: 320% 320%;
    animation: ef-account-app-gradient 12s ease-in-out infinite;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: calc(32px + var(--ef-safe-top)) calc(24px + var(--ef-safe-right))
        calc(48px + var(--ef-safe-bottom)) calc(24px + var(--ef-safe-left));
    box-sizing: border-box;
    font-family: 'Montserrat', system-ui, sans-serif;
}

@keyframes ef-account-app-gradient {
    0% {
        background-position: 0% 40%;
    }
    50% {
        background-position: 100% 60%;
    }
    100% {
        background-position: 0% 40%;
    }
}

@media (prefers-reduced-motion: reduce) {
    .ef-account-app-page {
        animation: none;
        background-size: 100% 100%;
        background-position: 50% 50%;
    }
}

.ef-account-app-page__inner {
    width: 100%;
    max-width: 380px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 28px;
}

.ef-account-app-page__claim {
    margin: 0;
    text-align: center;
    color: #ffffff;
    font-size: 1.05rem;
    font-weight: 600;
    line-height: 1.4;
    text-wrap: balance;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
}

.ef-account-app-page__logo {
    display: block;
    width: min(100%, 200px);
    height: auto;
    max-height: min(18dvh, 100px);
    object-fit: contain;
}

.ef-account-app-page__stores {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 100%;
}

@media (min-width: 480px) {
    .ef-account-app-page__stores {
        flex-direction: row;
        justify-content: center;
        flex-wrap: wrap;
    }
}

.ef-account-app-page__store-link {
    display: inline-block;
    line-height: 0;
}

/* I due badge hanno lo stesso viewBox (120×40): fissando l'altezza restano identici in scala. */
.ef-account-app-page__badge {
    display: block;
    height: 52px;
    width: auto;
}
</style>
